import { isEmpty } from "@swiggy-private/js-utils";
import { getFormattedNumber } from "@swiggy-private/super-ui";

const TOTAL_DISCOUNT_PLACEHOLDER = "{{total_discount}}";

export function interpolateTotalDiscountInSavingsCallout(
    text: string | undefined,
    totalDiscount: number | undefined,
): string {
    if (isEmpty(text)) {
        return "";
    }
    if (isEmpty(totalDiscount) || !text.includes(TOTAL_DISCOUNT_PLACEHOLDER)) {
        return text;
    }
    return text.split(TOTAL_DISCOUNT_PLACEHOLDER).join(`₹${getFormattedNumber(totalDiscount)}`);
}
